import { Feedback } from 'v2/core/entities/feedback';
import { EntityLabel, ReasonLabel } from 'v2/core/entities/feedback/labels';
import { UUID } from 'v2/core/entities/uuid';
import { FeedbackOptions } from 'v2/views/components/feedbackListViewer/types';

const getMatchedFeedbackRecords = (
  feedbacks: Feedback[],
  options?: FeedbackOptions,
) => {
  if (!options?.match?.type || options?.match?.type === 'SEARCH') {
    return feedbacks;
  }

  return getMatchedRecords(feedbacks, options.match.type, options?.match?.id);
};

const getMatchedRecords = (
  feedbacks: Feedback[],
  type: 'REASON' | 'ENTITY' | 'SEARCH',
  highlightID: UUID,
) => {
  switch (type) {
    case 'REASON':
      return getRecordsWithReasonSentiment(feedbacks, highlightID);
    case 'ENTITY':
      return getRecordsWithEntitySentiment(feedbacks, highlightID);
    default:
      throw new Error('Match Type not supported');
  }
};

const getRecordsWithReasonSentiment = (
  feedbacks: Feedback[],
  highlightID: UUID,
) => {
  return feedbacks.map((feedback) => {
    // TODO: Find a better way to do this
    const label = feedback.labels?.find((label) => label.id === highlightID) as
      | ReasonLabel
      | undefined;
    return {
      ...feedback,
      sentiment: label?.sentiment,
    };
  });
};

const getRecordsWithEntitySentiment = (
  feedbacks: Feedback[],
  highlightID: UUID,
) => {
  return feedbacks.map((feedback) => {
    // TODO: Find a better way to do this
    const label = feedback.labels?.find((label) => label.id === highlightID) as
      | EntityLabel
      | undefined;
    return {
      ...feedback,
      sentiment: label?.aggregatedSentiment,
    };
  });
};

export default getMatchedFeedbackRecords;
